<template>
  <v-container style="max-width: 100%">
    <v-data-table
      :headers="headersClientAgencies"
      :items="clientAgencies"
      class="elevation-1"
      :items-per-page="-1"
      disable-pagination
      hide-default-footer
      sort-by="organisationName"
    >
      <template v-slot:top>
        <v-toolbar
          flat
        >
          <v-toolbar-title>Client Agencies</v-toolbar-title>
          <v-spacer />
          <v-btn
            color="ppc_pink"
            dark
            small
            absolute
            right
            fab
            @click="dialogEditClientAgency=true"
          >
            <v-icon>$vuetify.icons.icon_mdi_plus</v-icon>
          </v-btn>
          <v-dialog
            v-model="dialogEditClientAgency"
            max-width="500px"
            persistent
          >
            <v-form ref="dialogForm">
              <v-card class="d-flex flex-column">
                <v-card-title class="ppc_darkgreen darken-1">
                  <span class="headline white--text">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-select
                    v-model="editedItem.organisation_id"
                    :items="selectContactsOrganisation"
                    item-text="name"
                    item-value="id"
                    :menu-props="{ auto: true }"
                    label="Select Organisation"
                    single-line
                    prepend-icon="$vuetify.icons.icon_mdi_domain ppc_darkgreen--text"
                    validate-on-blur
                    clearable
                    :rules="inputRulesReq"
                  />
                  <v-text-field
                    v-model.trim="editedItem.nameFormal"
                    label="Formal Name (on invoices)"
                    counter="100"
                  />
                  <v-text-field
                    v-model.trim="editedItem.idFormal"
                    label="Formal ID (accountancy purposes)"
                    counter="100"
                  />
                  <v-select
                    v-model="editedItem.salesContact_id"
                    :items="selectContactsStaff"
                    item-text="name"
                    item-value="id"
                    :menu-props="{ auto: true }"
                    label="Select Staff Member"
                    single-line
                    prepend-icon="$vuetify.icons.icon_mdi_account_group ppc_darkgreen--text"
                    validate-on-blur
                    clearable
                  />
                  <v-checkbox
                    v-model="editedItem.transferFeeIncluded"
                    label="Transfer Fee Included in payments (PPC pays)"
                  />
                  <v-checkbox
                    v-model="editedItem.sendHandbook"
                    label="Send PPC Handbook with every client"
                  />
                  <v-divider />
                  Send accommodation descriptions to:
                  <div class="d-flex flex-row">
                    <span style="width: 50%">
                      <v-select
                        v-model="editedItem.contactToEmail"
                        :items="selectContactsWithEmail"
                        item-text="full_name"
                        item-value="id"
                        :menu-props="{ auto: true }"
                        label="the client"
                        single-line
                        prepend-icon="$vuetify.icons.icon_mdi_domain ppc_darkgreen--text"
                        validate-on-blur
                        clearable
                      />
                    </span>
                    <span class="mt-6 mx-2">{{ getContact(editedItem.contactToEmail) }}</span>
                  </div>
                  <v-divider />
                  CC accommodation descriptions to:
                  <div class="d-flex flex-row">
                    <span style="width: 50%">
                      <v-select
                        v-model="editedItem.contactToCC"
                        :items="selectContactsWithEmail"
                        item-text="full_name"
                        item-value="id"
                        :menu-props="{ auto: true }"
                        label="nobody"
                        single-line
                        prepend-icon="$vuetify.icons.icon_mdi_domain ppc_darkgreen--text"
                        validate-on-blur
                        clearable
                      />
                    </span>
                    <span class="mt-6 mx-2">{{ getContact(editedItem.contactToCC) }}</span>
                  </div>
                  <v-divider />
                  <v-checkbox
                    v-model="editedItem.pass_to_planning"
                    label="Pass to Planning"
                  />
                  <v-divider />
                  <v-checkbox
                    :input-value="editedItem.obsolete !== null"
                    label="Obsolete"
                    @change="setObsolete"
                  />
                  <v-text-field
                    v-if="editedItem.obsolete !== null"
                    :value="formattedDate(editedItem.obsolete)"
                    disabled
                    label="From"
                    class="ml-2"
                  />
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    color="ppc_darkgreen darken-1"
                    text
                    @click="closeDialogEditClientAgency"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    color="ppc_darkgreen darken-1"
                    text
                    @click="saveClientAgency"
                  >
                    Save
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-dialog>
          <v-dialog
            v-model="dialogDelete"
            max-width="500px"
          >
            <v-card>
              <v-card-title>Are you sure you want to delete {{ editedItem.name }}?</v-card-title>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="ppc_darkgreen darken-1"
                  text
                  @click="closeDelete"
                >
                  Cancel
                </v-btn>
                <v-btn
                  color="ppc_darkgreen darken-1"
                  text
                  @click="deleteItemConfirm"
                >
                  OK
                </v-btn>
                <v-spacer />
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.transferFeeIncluded`]="{ item }">
        <v-icon
          v-if="item.transferFeeIncluded === 1"
          small
          color="ppc_darkgreen"
        >
          $vuetify.icons.icon_mdi_check
        </v-icon>
      </template>
      <template v-slot:[`item.sendHandbook`]="{ item }">
        <v-icon
          v-if="item.sendHandbook === 1"
          small
          color="ppc_darkgreen"
        >
          $vuetify.icons.icon_mdi_check
        </v-icon>
      </template>
      <template v-slot:[`item.pass_to_planning`]="{ item }">
        <v-icon
          v-if="item.pass_to_planning === 1"
          small
          color="ppc_darkgreen"
        >
          $vuetify.icons.icon_mdi_check
        </v-icon>
      </template>
      <template v-slot:[`item.obsolete`]="{ item }">
        <v-icon
          v-if="item.obsolete !== null"
          small
          color="ppc_pink"
        >
          $vuetify.icons.icon_mdi_cancel
        </v-icon>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-2"
              v-bind="attrs"
              v-on="on" 
              @click="goInvoice(item)"
            >
              mdi-file-chart
            </v-icon>
          </template>
          <span>Create Invoice</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-2"
              v-bind="attrs"
              v-on="on" 
              @click="editItem(item)"
            >
              $vuetify.icons.icon_mdi_pencil
            </v-icon>
          </template>
          <span>Edit Agency</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              v-bind="attrs"
              v-on="on" 
              @click="deleteItem(item)"
            >
              $vuetify.icons.icon_mdi_delete
            </v-icon>
          </template>
          <span>Delete Agency</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>

import dayjs from 'dayjs';
import inputRules from '../mixins/inputRules';
import formattedDate from '../mixins/formattedDate';
import compare from '../mixins/compare';

export default {

    mixins: [inputRules, formattedDate, compare],
    data: () => ({
      dialogEditClientAgency: false,
      dialogDelete: false,
      isNew: true,
      headersClientAgencies: [
        {
          text: 'Name',
          align: 'start',
          value: 'organisationName',
        },
        { text: 'Formal Name (on invoices)', value: 'nameFormal' },
        { text: 'Formal ID', value: 'idFormal' },
        { text: 'Contact PPC', value: 'salesContactName' },
        { text: 'Transfer Fee Included', value: 'transferFeeIncluded' },
        { text: 'Send PPC Handbook', value: 'sendHandbook' },
        { text: 'Pass to Planning', value: 'pass_to_planning' },
        { text: 'Obsolete', value: 'obsolete' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      editedItem: {
        name: '',
        contact_id: null,
        salesContact_id: null,
        transferFeeIncluded: 0,
        sendHandbook: 0,
        pass_to_planning: 0,
        contactToEmail: null,
        contactToCC: null,
        obsolete: null,
      },
      defaultItem: {
        name: '',
        contact_id: null,
        salesContact_id: null,
        transferFeeIncluded: 0,
        sendHandbook: 0,
        pass_to_planning: 0,
        contactToEmail: null,
        contactToCC: null,
        obsolete: null,
      },
    }),

    computed: {
        formTitle () {
            return this.isNew ? 'New Agency' : 'Edit Agency'
        },

        selectContactsStaff () {
            let staff = this.$store.state.contacts.filter(function(select_item) {
                return select_item.obsolete === null && select_item.staff > 0;
            })
            return staff.sort(this.dynamicSort('name'));
        },

        selectContactsWithEmail () {
            let contacts = this.$store.state.contacts.filter(function(select_item) {
                return select_item.obsolete === null && select_item.email !== null && select_item.email !== '';
            })
            return contacts.sort(this.dynamicSort('name'));
        },

        activeContacts() {
            return this.$store.state.contacts.filter(co => co.obsolete === null);
        },

        contactsById() {
            return new Map(
                this.$store.state.contacts.map(c => [c.id, c])
            );
        },

        organisationsById() {
            return new Map(
                this.$store.state.organisations.map(o => [o.id, o])
            );
        },

        clientAgencies() {
            return this.$store.getters.clientAgencies;
        },

        selectContactsOrganisation () {
            let organisations = this.$store.state.organisations;
            for (let index = 0; index < organisations.length; index++) {
                organisations[index].organisation = organisations[index].name;
            }
            return organisations.sort(this.dynamicSort('name'));
        },

    },

    watch: {
    },

    beforeCreate () {
        if (this.$store.state.accessClientAgencies === 0) {
            this.$router.push({ name: 'Illegal' })
        }
        this.$store.dispatch('setLoadingApp', 1)
    },

    created () {
        dayjs.locale("en");
        this.initialize()
    },

    methods: {
        async initialize () {

            await this.getData();
            
            let breadcrumb =  JSON.parse(JSON.stringify(this.$store.state.breadcrumbs));
            breadcrumb.push('ClientAgencies');
            await this.$store.dispatch('breadcrumbs', breadcrumb);
            this.$store.dispatch('setLoadingApp', 0);

        },

        async getData() {
            this.$store.dispatch('setLoadingApp', 1);

            await Promise.all([
                this.$store.dispatch('getContacts'),
                this.$store.dispatch('getOrganisations'),
                this.$store.dispatch('getAvailableAgencies'),
            ]);

            this.$store.dispatch('setLoadingApp', 0);
        },

        newClientAgency() {
            this.isNew = true;
            this.dialogEditClientAgency = true;
        },

        editItem (item) {
            this.isNew = false;
            this.editedItem = { ...item }
            this.dialogEditClientAgency = true
        },

        async deleteItem (item) {
            this.isNew = false;
            this.editedItem = { ...item }
            this.dialogDelete = true
        },

        async deleteItemConfirm () {
            let response = await this.$store.dispatch('deleteClientAgency', this.editedItem.id);
            if (response.data.affectedRows === 1) {
                this.$store.dispatch('successMessage', 'Agency deleted');
                await this.$store.dispatch('getAvailableAgencies');
            } else {
                this.$store.dispatch('errorMessage', 'Something went wrong');
            }
            await this.getData();
            this.closeDelete()
        },

        setObsolete(event) {
            if (event) {
                this.editedItem.obsolete = dayjs().format("YYYY-MM-DD")
            } else {
                this.editedItem.obsolete = null
            }
        },

        closeDialogEditClientAgency() {
            this.dialogEditClientAgency = false
            this.isNew = true
            this.editedItem = { ...this.defaultItem }
        },

        closeDelete () {
            this.dialogDelete = false
            this.isNew = true
            this.editedItem = { ...this.defaultItem }
        },

        async saveClientAgency () {
            if(this.$refs.dialogForm.validate()){

                const normalizedNameFormal = (this.editedItem.nameFormal || '')
                    .trim()
                    .toLowerCase();

                const duplicateNameFormal = this.clientAgencies.some(a =>
                    (a.nameFormal || '').trim().toLowerCase() === normalizedNameFormal &&
                    a.id !== this.editedItem.id
                );

                if (duplicateNameFormal) {
                    this.$store.dispatch(
                        'errorMessage',
                        `The name "${this.editedItem.nameFormal}" is already in use!`
                    );
                    return;
                }

                const duplicateOrganisation = this.clientAgencies.some(a =>
                    Number(a.organisation_id) === Number(this.editedItem.organisation_id) &&
                    a.id !== this.editedItem.id
                );

                if (duplicateOrganisation) {
                    this.$store.dispatch(
                        'errorMessage',
                        'This organisation already has an agency assigned.'
                    );
                    return;
                }

                console.log('saveClientAgency', this.editedItem);
                await this.$store.dispatch('insertClientAgency', this.editedItem);
                await this.getData();
                this.closeDialogEditClientAgency()
            }
        },


        async goInvoice (item) {
            const date = new Date();
            let idAppNew = date.getTime();
            let newApp = {};
            newApp.id = idAppNew;
            newApp.autoAppTitle = false;
            newApp.amountOfClients = 1;
            newApp.frozen = false;
            newApp.payerAgency = item.id;
            newApp.payerClient = null;
            newApp.pass_to_planning = true;
            let agency_id = item.id;
            let tmp = this.$store.state.available_agencies.filter(function(select_item) {
                return select_item.id === agency_id;
            });
            newApp.transferFeeIncluded = tmp[0].transferFeeIncluded;
            newApp.appTitle = 'Agency Invoice';
            newApp.exchangeRate = this.$store.state.exchangeRate;
            let payload = {
                client: null,
                applications: [],
                services: null,
                radioGroups: null,
                radioOptions: null,
                options: null,
                resources: null,
            };
            newApp.fixedPrice = null;
            newApp.discount = null;
            newApp.discountPercentage = null;
            newApp.refund = null;
            payload.applications.push(newApp);
            await this.$store.dispatch('insertUpdateMainItems', payload);
            await this.$store.dispatch('saveDataForReport', newApp);
            this.$store.dispatch('showApplication', true);
        },
        
        getContact (id) {
            let contact = this.$store.state.contacts.filter(function(select_item) {
                return select_item.id === id;
            })
            if (contact.length === 0) {
                return null;
            } else {
                return contact[0].email;
            }
        },
    },
  }

</script>

<style>
    .v-card__title {
        color: #35b729;
        word-break: normal !important;
    }
    .v-card__subtitle { padding-top: 0; padding-bottom: 0;}
    .pos_absolute {
        position: absolute;
    }
</style>